import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';


import Hero from '../sections/Hero';
import About from '../sections/About';
import Vision from '../sections/Vision';
import Team from '../sections/Team';
import Pipeline from '../sections/Pipeline';
import Science from '../sections/Science';
import Contact from '../sections/Contact';
import AnnouncementBar from '../components/AnnouncementBar';

const Home = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const targetId = location.state.scrollTo;
      const element = document.getElementById(targetId);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, [location]);

  return (
    <div>
      <AnnouncementBar />
      <Hero />
      <About />
      <Vision />
      <Science />
      <Pipeline />
      <Team />
      <Contact />
    </div>
  );
};

export default Home;
